import { InjectionToken } from '@angular/core';
import { IModelDataV1 } from '@df/catalog/model';
import { ISizeId, ISizeName } from '@df/core/service/client';
import { Search } from '@df/search/search.interfaces';
import { NICmsContentField } from '@icms/core/content';
import { Nexus } from '@tomandco/nexus-api-types';

export namespace NICmsClientConfig {
    export interface IConfig {
        modules?: {
            campaigns?: {
                enabled: boolean;
            };
            templates?: {
                enabled: boolean;
            };
            markerIo?: {
                enabled: boolean;
            };
            merchandiser?: {
                enabled: boolean;
                indicatorShift: [string, string, string, string];
            };
            pdpDisplayRules?: {
                enabled: boolean;
            };
            translations?: {
                enabled: boolean;
            };
        };
        sizes: ISize[];
        colors: IColorConfig[];
        ratios?: NICmsContentField.IOption<string>[];
        // wrap: [IWrapSettings, IWrapSettings, IWrapSettings, IWrapSettings]; // maybe at some point
        spacings: NICmsContentField.IOption<string>[] | ((sizeId: ISizeId) => NICmsContentField.IOption<string>[]);
        resourcesMockup?: IResourcesMockup;
        specialPagesMockup?: ISpecialPagesMockup;
    }

    // type IWrapSettings {
    //     width : number,
    //     gutter : number,
    //     columns : number,
    // }

    export interface IColorConfig extends NICmsContentField.IOption<string> {
        value: string;
    }

    export interface IResourcesMockup {
        [key: string]: Array<IModelDataV1 & { [key: string]: any }>;
    }

    export interface ISpecialPagesMockup {
        checkoutSuccess: Nexus.Api.Checkout.Success.ISuccessData & { [key: string]: any };
        search: {
            term: string;
            data: Search.IResult;
            options: Search.ISearchResultOptions;
        } & { [key: string]: any };
        error500Page?: {
            url: string;
        };
        pageNotFound?: {
            url: string;
        };
    }

    export interface ISize {
        /**
         * Size identifier
         */
        id: ISizeName;
        /**
         * Size label
         */
        label: string;
        /**
         * App width
         */
        width: number;
        /**
         * Non full-scree-mode height
         */
        height?: number;
        /**
         * Used if no other is defined
         */
        default?: boolean;
    }
}
export const ICMS_CLIENT_CONFIG = new InjectionToken<NICmsClientConfig.IConfig>('ICMS_CONFIG');

export const ICMS_CLIENT_CONFIG_DEFAULT = {
    modules: {
        markerIo: {
            enabled: true
        }
    }
};

export enum EICmsClientPermissions {
    cms = 'cms',
    edit = 'cms_edit',
    publish = 'cms_publish',
    media = 'cms_media',
    components = 'cms_components',
    reindex = 'cms_reindex'
}
